import { ContentBlockWrapper } from "../../components/markdown/ContentBlockWrapper";
import { sameNodePosition, } from "../../components/markdown/utils";
import { ScrollArea, ScrollBar } from "../../components/ScrollArea";
import React, { memo, useMemo } from "react";
const getNodeText = (node) => {
    if (["string", "number"].includes(typeof node)) {
        return node;
    }
    if (node instanceof Array) {
        return node.map(getNodeText).join("");
    }
    if (node && typeof node === "object" && "props" in node) {
        return getNodeText(node.props.children);
    }
    return "";
};
export const TableBlock = memo(({ children }) => {
    const tableData = useMemo(() => {
        const [headNode, bodyNode] = Array.from(children);
        if (!headNode ||
            !bodyNode ||
            !("props" in headNode) ||
            !("props" in bodyNode)) {
            return;
        }
        const headCells = headNode.props.children[0].props.children.map((c) => getNodeText(c.props.children));
        const headHtml = `<thead><tr>${headCells
            .map((c) => `<th><b>${c}</b></th>`)
            .join("")}</tr></thead>`;
        const headPlain = headCells.join("\t");
        const bodyRows = bodyNode.props.children.map((row) => row.props.children.map((cell) => {
            const children = cell.props.children;
            return (Array.isArray(children) ? children : [children])
                .map((child) => { var _a; return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.name) === "CiteBlock" ? "" : getNodeText(child); })
                .join("");
        }));
        const bodyHtml = `<tbody>${bodyRows
            .map((row) => {
            return `<tr>${row
                .map((cell) => `<td>${cell}</td>`)
                .join("")}</tr>`;
        })
            .join("")}</tbody>`;
        const bodyPlain = bodyRows.map((row) => row.join("\t")).join("\n");
        return {
            "text/html": `<table>${headHtml}${bodyHtml}</table>`,
            "text/plain": headPlain + "\n" + bodyPlain,
        };
    }, [children]);
    return (React.createElement(ContentBlockWrapper, { innerClassName: "relative my-2 w-full border border-border rounded-2xl", content: tableData },
        React.createElement(ScrollArea, { scrollContainment: "horizontal", className: "w-full rounded-2xl" },
            React.createElement("table", { className: "w-full" }, children),
            React.createElement(ScrollBar, { orientation: "horizontal" }))));
}, (prev, next) => sameNodePosition(prev.node, next.node));
TableBlock.displayName = "TableBlock";
export const TableHeadBlock = memo(({ children }) => {
    return React.createElement("thead", { className: "bg-muted-background px-2 py-2" }, children);
}, (prev, next) => sameNodePosition(prev.node, next.node));
TableHeadBlock.displayName = "TableHeadBlock";
export const TableBodyBlock = memo(({ children }) => {
    return React.createElement("tbody", { className: "bg-background" }, children);
}, (prev, next) => sameNodePosition(prev.node, next.node));
TableBodyBlock.displayName = "TableBodyBlock";
export const TableHeaderBlock = memo(({ children }) => {
    return (React.createElement("th", { className: "truncate whitespace-nowrap break-words py-3.5 pl-4 text-left text-xs font-semibold text-muted-foreground" }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node));
TableHeaderBlock.displayName = "TableHeaderBlock";
export const TableDataBlock = memo(({ children }) => {
    return (React.createElement("td", { className: "px-4 py-3 text-sm text-foreground" }, Array.isArray(children) ? (children.map((child, i) => {
        if (child === "<br>") {
            return React.createElement("br", { key: i });
        }
        return React.createElement(React.Fragment, { key: i }, child);
    })) : (React.createElement(React.Fragment, null, children))));
}, (prev, next) => sameNodePosition(prev.node, next.node));
TableDataBlock.displayName = "TableDataBlock";
//# sourceMappingURL=TableBlock.js.map